// extracted by mini-css-extract-plugin
export var chip = "_5q-9";
export var chipLabel = "_5q-a";
export var close = "_5q-7";
export var closeIcon = "_5q-8";
export var error = "_5q-6";
export var infoTooltip = "_5q-2";
export var innerContainer = "_5q-1";
export var input = "_5q-b";
export var medium = "_5q-5";
export var outerContainer = "_5q-0";
export var small = "_5q-4";
export var xSmall = "_5q-3";